/** Query/hash helpers for password recovery (verify-on-submit, prefetch-safe). */

export function getRecoveryTokenFromSearch(search: string): string | null {
  const token = new URLSearchParams(search).get('token_hash');
  return token?.trim() ? token : null;
}

export function parseAuthHash(hash: string): URLSearchParams {
  const raw = hash.replace(/^#/, '');
  return raw ? new URLSearchParams(raw) : new URLSearchParams();
}

/** Legacy implicit flow after Supabase /auth/v1/verify redirect. */
export function isImplicitRecoveryHash(hash: string): boolean {
  if (!hash || hash.length < 2) return false;
  const params = parseAuthHash(hash);
  return params.get('type') === 'recovery' && params.has('access_token');
}

export function buildRecoveryPageSearch(tokenHash: string): string {
  const q = new URLSearchParams({ type: 'recovery', token_hash: tokenHash });
  return `?${q.toString()}`;
}

export function validateRecoveryPassword(
  password: string,
  confirm: string
): string | null {
  if (password.length < 6) {
    return 'La contraseña debe tener al menos 6 caracteres';
  }
  if (password !== confirm) {
    return 'Las contraseñas no coinciden';
  }
  return null;
}

export function recoveryVerifyErrorMessage(err: unknown): string {
  const msg = err instanceof Error ? err.message : '';
  if (/expired|invalid|already been used|otp_expired/i.test(msg)) {
    return 'Enlace de restablecimiento inválido o expirado. Solicita uno nuevo.';
  }
  return msg || 'No se pudo verificar el enlace. Solicita uno nuevo.';
}
